import { render } from "./productInfo.vue?vue&type=template&id=f1fbc166&scoped=true"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"

import "./productInfo.vue?vue&type=style&index=0&id=f1fbc166&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1fbc166"]])

export default __exports__